import React, { Fragment } from 'react';
import { createUseEntryPointContext, useEntryPoint } from '@atlassian/jira-entry-point';
import { componentWithCondition, componentWithFF } from '@atlassian/jira-feature-flagging-utils';
import { issueSmartRequestSummaryEntryPoint } from '@atlassian/jira-issue-smart-request-summary/entrypoint';
import { jsmSmartRequestSummaryEntryPoint } from '@atlassian/jira-servicedesk-smart-request-summary/entrypoint';
import { isJsmSmartRequestSummaryEnabled } from './feature-flags';

export const JsmSmartRequestSummaryEntryPointContext =
	createUseEntryPointContext<typeof jsmSmartRequestSummaryEntryPoint>();

// rename to JsmSmartRequestSummaryEntryPointContextProvider when cleaning up enable-jsm-smart-request-summary_kva1r
// and export this
const EnabledJsmSmartRequestSummaryEntryPointContextProvider = ({
	children,
}: React.PropsWithChildren<{}>) => {
	const entryPoint = useEntryPoint(jsmSmartRequestSummaryEntryPoint, {});

	return (
		<JsmSmartRequestSummaryEntryPointContext.Provider value={entryPoint}>
			{children}
		</JsmSmartRequestSummaryEntryPointContext.Provider>
	);
};
// update displayName when cleaning up enable-jsm-smart-request-summary_kva1r
EnabledJsmSmartRequestSummaryEntryPointContextProvider.displayName =
	'EnabledJsmSmartRequestSummaryEntryPointContextProvider';

// remove when cleaning up enable-jsm-smart-request-summary_kva1r
export const JsmSmartRequestSummaryEntryPointContextProvider = componentWithCondition(
	isJsmSmartRequestSummaryEnabled,
	EnabledJsmSmartRequestSummaryEntryPointContextProvider,
	Fragment,
);
JsmSmartRequestSummaryEntryPointContextProvider.displayName =
	'JsmSmartRequestSummaryEntryPointContextProvider';

export const IssueSmartRequestSummaryEntryPointContext =
	createUseEntryPointContext<typeof issueSmartRequestSummaryEntryPoint>();

const EMPTY_ENTRY_POINT_PARAMS = {};

const EnabledIssueSmartRequestSummaryEntryPointContextProvider = ({
	children,
}: React.PropsWithChildren<{}>) => {
	const entryPoint = useEntryPoint(issueSmartRequestSummaryEntryPoint, EMPTY_ENTRY_POINT_PARAMS);

	return (
		<IssueSmartRequestSummaryEntryPointContext.Provider value={entryPoint}>
			{children}
		</IssueSmartRequestSummaryEntryPointContext.Provider>
	);
};

EnabledIssueSmartRequestSummaryEntryPointContextProvider.displayName =
	'EnabledIssueSmartRequestSummaryEntryPointContextProvider';

export const IssueSmartRequestSummaryEntryPointContextProvider = componentWithFF(
	'issue.details.jira-smart-summary-platform_0jta9',
	EnabledIssueSmartRequestSummaryEntryPointContextProvider,
	Fragment,
);
IssueSmartRequestSummaryEntryPointContextProvider.displayName =
	'IssueSmartRequestSummaryEntryPointContextProvider';
